/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompleteBillingsCsvRequest,
  ListBillings200Response,
  ListOperations400Response,
  UpdateBillingCancellationFee200Response,
  UpdateBillingCancellationFeeRequest,
  UpdateBillingFareRequest,
  UpdateBillingTipRequest,
  UploadBillingsCsv200Response,
} from '../models/index';
import {
    CompleteBillingsCsvRequestFromJSON,
    CompleteBillingsCsvRequestToJSON,
    ListBillings200ResponseFromJSON,
    ListBillings200ResponseToJSON,
    ListOperations400ResponseFromJSON,
    ListOperations400ResponseToJSON,
    UpdateBillingCancellationFee200ResponseFromJSON,
    UpdateBillingCancellationFee200ResponseToJSON,
    UpdateBillingCancellationFeeRequestFromJSON,
    UpdateBillingCancellationFeeRequestToJSON,
    UpdateBillingFareRequestFromJSON,
    UpdateBillingFareRequestToJSON,
    UpdateBillingTipRequestFromJSON,
    UpdateBillingTipRequestToJSON,
    UploadBillingsCsv200ResponseFromJSON,
    UploadBillingsCsv200ResponseToJSON,
} from '../models/index';

export interface BillingsCsvExportRequest {
    createdAtFrom?: Date;
    createdAtTo?: Date;
    orderNo?: string;
    externalOrderNo?: string;
    latest?: boolean;
    serviceCategory?: BillingsCsvExportServiceCategoryEnum;
    category?: BillingsCsvExportCategoryEnum;
    requestSourceType?: BillingsCsvExportRequestSourceTypeEnum;
    carStatus?: BillingsCsvExportCarStatusEnum;
    paymentMethod?: BillingsCsvExportPaymentMethodEnum;
    radioNo?: string;
    driverName?: string;
    groupName?: string;
    companyName?: string;
    salesOfficeName?: string;
    sort?: BillingsCsvExportSortEnum;
}

export interface CompleteBillingsCsvOperationRequest {
    completeBillingsCsvRequest: CompleteBillingsCsvRequest;
}

export interface ListBillingsRequest {
    page?: number;
    count?: number;
    createdAtFrom?: Date;
    createdAtTo?: Date;
    orderNo?: string;
    externalOrderNo?: string;
    latest?: boolean;
    serviceCategory?: ListBillingsServiceCategoryEnum;
    category?: ListBillingsCategoryEnum;
    requestSourceType?: ListBillingsRequestSourceTypeEnum;
    carStatus?: ListBillingsCarStatusEnum;
    paymentMethod?: ListBillingsPaymentMethodEnum;
    radioNo?: string;
    driverName?: string;
    groupName?: string;
    companyName?: string;
    salesOfficeName?: string;
    sort?: ListBillingsSortEnum;
}

export interface UpdateBillingCancellationFeeOperationRequest {
    billingId: string;
    updateBillingCancellationFeeRequest: UpdateBillingCancellationFeeRequest;
}

export interface UpdateBillingFareOperationRequest {
    billingId: string;
    updateBillingFareRequest: UpdateBillingFareRequest;
}

export interface UpdateBillingTipOperationRequest {
    billingId: string;
    updateBillingTipRequest: UpdateBillingTipRequest;
}

export interface UploadBillingsCsvRequest {
    file: Blob;
}

/**
 * 
 */
export class BillingsApi extends runtime.BaseAPI {

    /**
     * 伝票CSVエクスポート
     */
    async billingsCsvExportRaw(requestParameters: BillingsCsvExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['createdAtFrom'] != null) {
            queryParameters['created_at_from'] = (requestParameters['createdAtFrom'] as any).toISOString();
        }

        if (requestParameters['createdAtTo'] != null) {
            queryParameters['created_at_to'] = (requestParameters['createdAtTo'] as any).toISOString();
        }

        if (requestParameters['orderNo'] != null) {
            queryParameters['order_no'] = requestParameters['orderNo'];
        }

        if (requestParameters['externalOrderNo'] != null) {
            queryParameters['external_order_no'] = requestParameters['externalOrderNo'];
        }

        if (requestParameters['latest'] != null) {
            queryParameters['latest'] = requestParameters['latest'];
        }

        if (requestParameters['serviceCategory'] != null) {
            queryParameters['service_category'] = requestParameters['serviceCategory'];
        }

        if (requestParameters['category'] != null) {
            queryParameters['category'] = requestParameters['category'];
        }

        if (requestParameters['requestSourceType'] != null) {
            queryParameters['request_source_type'] = requestParameters['requestSourceType'];
        }

        if (requestParameters['carStatus'] != null) {
            queryParameters['car_status'] = requestParameters['carStatus'];
        }

        if (requestParameters['paymentMethod'] != null) {
            queryParameters['payment_method'] = requestParameters['paymentMethod'];
        }

        if (requestParameters['radioNo'] != null) {
            queryParameters['radio_no'] = requestParameters['radioNo'];
        }

        if (requestParameters['driverName'] != null) {
            queryParameters['driver_name'] = requestParameters['driverName'];
        }

        if (requestParameters['groupName'] != null) {
            queryParameters['group_name'] = requestParameters['groupName'];
        }

        if (requestParameters['companyName'] != null) {
            queryParameters['company_name'] = requestParameters['companyName'];
        }

        if (requestParameters['salesOfficeName'] != null) {
            queryParameters['sales_office_name'] = requestParameters['salesOfficeName'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/billings/csv/export`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * 伝票CSVエクスポート
     */
    async billingsCsvExport(requestParameters: BillingsCsvExportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.billingsCsvExportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 伝票一括登録完了
     */
    async completeBillingsCsvRaw(requestParameters: CompleteBillingsCsvOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['completeBillingsCsvRequest'] == null) {
            throw new runtime.RequiredError(
                'completeBillingsCsvRequest',
                'Required parameter "completeBillingsCsvRequest" was null or undefined when calling completeBillingsCsv().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/billings/csv/complete`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompleteBillingsCsvRequestToJSON(requestParameters['completeBillingsCsvRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 伝票一括登録完了
     */
    async completeBillingsCsv(requestParameters: CompleteBillingsCsvOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.completeBillingsCsvRaw(requestParameters, initOverrides);
    }

    /**
     * 伝票一覧
     */
    async listBillingsRaw(requestParameters: ListBillingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListBillings200Response>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }

        if (requestParameters['createdAtFrom'] != null) {
            queryParameters['created_at_from'] = (requestParameters['createdAtFrom'] as any).toISOString();
        }

        if (requestParameters['createdAtTo'] != null) {
            queryParameters['created_at_to'] = (requestParameters['createdAtTo'] as any).toISOString();
        }

        if (requestParameters['orderNo'] != null) {
            queryParameters['order_no'] = requestParameters['orderNo'];
        }

        if (requestParameters['externalOrderNo'] != null) {
            queryParameters['external_order_no'] = requestParameters['externalOrderNo'];
        }

        if (requestParameters['latest'] != null) {
            queryParameters['latest'] = requestParameters['latest'];
        }

        if (requestParameters['serviceCategory'] != null) {
            queryParameters['service_category'] = requestParameters['serviceCategory'];
        }

        if (requestParameters['category'] != null) {
            queryParameters['category'] = requestParameters['category'];
        }

        if (requestParameters['requestSourceType'] != null) {
            queryParameters['request_source_type'] = requestParameters['requestSourceType'];
        }

        if (requestParameters['carStatus'] != null) {
            queryParameters['car_status'] = requestParameters['carStatus'];
        }

        if (requestParameters['paymentMethod'] != null) {
            queryParameters['payment_method'] = requestParameters['paymentMethod'];
        }

        if (requestParameters['radioNo'] != null) {
            queryParameters['radio_no'] = requestParameters['radioNo'];
        }

        if (requestParameters['driverName'] != null) {
            queryParameters['driver_name'] = requestParameters['driverName'];
        }

        if (requestParameters['groupName'] != null) {
            queryParameters['group_name'] = requestParameters['groupName'];
        }

        if (requestParameters['companyName'] != null) {
            queryParameters['company_name'] = requestParameters['companyName'];
        }

        if (requestParameters['salesOfficeName'] != null) {
            queryParameters['sales_office_name'] = requestParameters['salesOfficeName'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/billings`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListBillings200ResponseFromJSON(jsonValue));
    }

    /**
     * 伝票一覧
     */
    async listBillings(requestParameters: ListBillingsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListBillings200Response> {
        const response = await this.listBillingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 伝票の修正(キャンセル料)
     */
    async updateBillingCancellationFeeRaw(requestParameters: UpdateBillingCancellationFeeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateBillingCancellationFee200Response>> {
        if (requestParameters['billingId'] == null) {
            throw new runtime.RequiredError(
                'billingId',
                'Required parameter "billingId" was null or undefined when calling updateBillingCancellationFee().'
            );
        }

        if (requestParameters['updateBillingCancellationFeeRequest'] == null) {
            throw new runtime.RequiredError(
                'updateBillingCancellationFeeRequest',
                'Required parameter "updateBillingCancellationFeeRequest" was null or undefined when calling updateBillingCancellationFee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/billings/{billing_id}/cancelrefund`;
        urlPath = urlPath.replace(`{${"billing_id"}}`, encodeURIComponent(String(requestParameters['billingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBillingCancellationFeeRequestToJSON(requestParameters['updateBillingCancellationFeeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateBillingCancellationFee200ResponseFromJSON(jsonValue));
    }

    /**
     * 伝票の修正(キャンセル料)
     */
    async updateBillingCancellationFee(requestParameters: UpdateBillingCancellationFeeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateBillingCancellationFee200Response> {
        const response = await this.updateBillingCancellationFeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 伝票の修正(乗車料金)
     */
    async updateBillingFareRaw(requestParameters: UpdateBillingFareOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateBillingCancellationFee200Response>> {
        if (requestParameters['billingId'] == null) {
            throw new runtime.RequiredError(
                'billingId',
                'Required parameter "billingId" was null or undefined when calling updateBillingFare().'
            );
        }

        if (requestParameters['updateBillingFareRequest'] == null) {
            throw new runtime.RequiredError(
                'updateBillingFareRequest',
                'Required parameter "updateBillingFareRequest" was null or undefined when calling updateBillingFare().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/billings/{billing_id}/taxifare`;
        urlPath = urlPath.replace(`{${"billing_id"}}`, encodeURIComponent(String(requestParameters['billingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBillingFareRequestToJSON(requestParameters['updateBillingFareRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateBillingCancellationFee200ResponseFromJSON(jsonValue));
    }

    /**
     * 伝票の修正(乗車料金)
     */
    async updateBillingFare(requestParameters: UpdateBillingFareOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateBillingCancellationFee200Response> {
        const response = await this.updateBillingFareRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 伝票の修正(チップ)
     */
    async updateBillingTipRaw(requestParameters: UpdateBillingTipOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateBillingCancellationFee200Response>> {
        if (requestParameters['billingId'] == null) {
            throw new runtime.RequiredError(
                'billingId',
                'Required parameter "billingId" was null or undefined when calling updateBillingTip().'
            );
        }

        if (requestParameters['updateBillingTipRequest'] == null) {
            throw new runtime.RequiredError(
                'updateBillingTipRequest',
                'Required parameter "updateBillingTipRequest" was null or undefined when calling updateBillingTip().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/billings/{billing_id}/tip`;
        urlPath = urlPath.replace(`{${"billing_id"}}`, encodeURIComponent(String(requestParameters['billingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBillingTipRequestToJSON(requestParameters['updateBillingTipRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateBillingCancellationFee200ResponseFromJSON(jsonValue));
    }

    /**
     * 伝票の修正(チップ)
     */
    async updateBillingTip(requestParameters: UpdateBillingTipOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateBillingCancellationFee200Response> {
        const response = await this.updateBillingTipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 伝票一括登録（CSVアップロード）
     */
    async uploadBillingsCsvRaw(requestParameters: UploadBillingsCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadBillingsCsv200Response>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadBillingsCsv().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/billings/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadBillingsCsv200ResponseFromJSON(jsonValue));
    }

    /**
     * 伝票一括登録（CSVアップロード）
     */
    async uploadBillingsCsv(requestParameters: UploadBillingsCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadBillingsCsv200Response> {
        const response = await this.uploadBillingsCsvRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const BillingsCsvExportServiceCategoryEnum = {
    OVERSEAS_ROAMING: 0
} as const;
export type BillingsCsvExportServiceCategoryEnum = typeof BillingsCsvExportServiceCategoryEnum[keyof typeof BillingsCsvExportServiceCategoryEnum];
/**
 * @export
 */
export const BillingsCsvExportCategoryEnum = {
    NORMAL: 0,
    CANCELLATION_FEE: 1,
    TIP: 2
} as const;
export type BillingsCsvExportCategoryEnum = typeof BillingsCsvExportCategoryEnum[keyof typeof BillingsCsvExportCategoryEnum];
/**
 * @export
 */
export const BillingsCsvExportRequestSourceTypeEnum = {
    SRIDE: 0,
    DIDI: 1,
    UBER: 2,
    RINGO_PASS: 3,
    SIMPLE_DISPATCH: 4
} as const;
export type BillingsCsvExportRequestSourceTypeEnum = typeof BillingsCsvExportRequestSourceTypeEnum[keyof typeof BillingsCsvExportRequestSourceTypeEnum];
/**
 * @export
 */
export const BillingsCsvExportCarStatusEnum = {
    REQUESTED: 1,
    SEARCH_FAILED: 2,
    DISPATCHED: 3,
    ARRIVED: 4,
    ON_BOARD: 5,
    SUBSTITUTE_REQUESTED: 6,
    PAYMENT_COMPLETED: 7,
    ONLINE_PAYMENT_FAILED: 8,
    ON_BOARD_QR: 9,
    UNUSED: 10,
    USER_CANCELED: 11,
    OPERATOR_CANCELED: 12,
    QR_CANCELED: 13
} as const;
export type BillingsCsvExportCarStatusEnum = typeof BillingsCsvExportCarStatusEnum[keyof typeof BillingsCsvExportCarStatusEnum];
/**
 * @export
 */
export const BillingsCsvExportPaymentMethodEnum = {
    IN_CAR_PAYMENT: '0',
    APP_PAYMENT_CREDIT_CARD: '1',
    EITHER: '2',
    APP_PAYMENT_APPLE_PAY: '3',
    RINGO_PASS_PAYMENT: '4',
    BACK_SEAT_PAYMENT: '5',
    APP_PAYMENT_CAB_CARD: '6',
    APP_PAYMENT_S_RIDE_BIZ: '7',
    APP_PAY_PAY: '10',
    APP_AU_PAY: '11',
    APP_D_PAY: '12',
    APP_R_PAY: '13',
    DIDI: '14',
    UBER: '15'
} as const;
export type BillingsCsvExportPaymentMethodEnum = typeof BillingsCsvExportPaymentMethodEnum[keyof typeof BillingsCsvExportPaymentMethodEnum];
/**
 * @export
 */
export const BillingsCsvExportSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type BillingsCsvExportSortEnum = typeof BillingsCsvExportSortEnum[keyof typeof BillingsCsvExportSortEnum];
/**
 * @export
 */
export const ListBillingsServiceCategoryEnum = {
    OVERSEAS_ROAMING: 0
} as const;
export type ListBillingsServiceCategoryEnum = typeof ListBillingsServiceCategoryEnum[keyof typeof ListBillingsServiceCategoryEnum];
/**
 * @export
 */
export const ListBillingsCategoryEnum = {
    NORMAL: 0,
    CANCELLATION_FEE: 1,
    TIP: 2
} as const;
export type ListBillingsCategoryEnum = typeof ListBillingsCategoryEnum[keyof typeof ListBillingsCategoryEnum];
/**
 * @export
 */
export const ListBillingsRequestSourceTypeEnum = {
    SRIDE: 0,
    DIDI: 1,
    UBER: 2,
    RINGO_PASS: 3,
    SIMPLE_DISPATCH: 4
} as const;
export type ListBillingsRequestSourceTypeEnum = typeof ListBillingsRequestSourceTypeEnum[keyof typeof ListBillingsRequestSourceTypeEnum];
/**
 * @export
 */
export const ListBillingsCarStatusEnum = {
    REQUESTED: 1,
    SEARCH_FAILED: 2,
    DISPATCHED: 3,
    ARRIVED: 4,
    ON_BOARD: 5,
    SUBSTITUTE_REQUESTED: 6,
    PAYMENT_COMPLETED: 7,
    ONLINE_PAYMENT_FAILED: 8,
    ON_BOARD_QR: 9,
    UNUSED: 10,
    USER_CANCELED: 11,
    OPERATOR_CANCELED: 12,
    QR_CANCELED: 13
} as const;
export type ListBillingsCarStatusEnum = typeof ListBillingsCarStatusEnum[keyof typeof ListBillingsCarStatusEnum];
/**
 * @export
 */
export const ListBillingsPaymentMethodEnum = {
    IN_CAR_PAYMENT: '0',
    APP_PAYMENT_CREDIT_CARD: '1',
    EITHER: '2',
    APP_PAYMENT_APPLE_PAY: '3',
    RINGO_PASS_PAYMENT: '4',
    BACK_SEAT_PAYMENT: '5',
    APP_PAYMENT_CAB_CARD: '6',
    APP_PAYMENT_S_RIDE_BIZ: '7',
    APP_PAY_PAY: '10',
    APP_AU_PAY: '11',
    APP_D_PAY: '12',
    APP_R_PAY: '13',
    DIDI: '14',
    UBER: '15'
} as const;
export type ListBillingsPaymentMethodEnum = typeof ListBillingsPaymentMethodEnum[keyof typeof ListBillingsPaymentMethodEnum];
/**
 * @export
 */
export const ListBillingsSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListBillingsSortEnum = typeof ListBillingsSortEnum[keyof typeof ListBillingsSortEnum];
